module.exports = __webpack_public_path__ + "static/media/36.67f921ab.wav";